<template>
<div>
    <div :class="{'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187}"></div>
    <div class="area-1290 purchase-orderlist-main">
        <div class="controller-container">
            <div class="controller-content">
                <el-radio-group @change="getOrderListByCheckStatus(checkStatusRadio)" class="" v-model="checkStatusRadio">
                    <el-radio :label="0">未审核</el-radio>
                    <el-radio class="radio-last" :label="1">已审核</el-radio>
                </el-radio-group>
                <el-date-picker class="timer" value-format="yyyy-MM-dd" format="yyyy-MM-dd" @change="searchOrderListByTime" v-model="timerValue" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['12:00:00']">
                </el-date-picker>
            </div>
        </div>
        <div class="table-container">
            <el-table :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="order_id" label="订单号" align="center" min-width="25%">
                </el-table-column>
                <el-table-column prop="create_time" label="日期" align="center" min-width="25%">
                </el-table-column>
                <el-table-column prop="status" label="审核状态" align="center" min-width="25%">
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="25%">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';
import Tool from '../../assets/js/Tool.js';
export default {
    data() {
        return {
            isHide: true,
            isBgHeaderH187: false,
            checkStatusRadio: 0,
            style: '',
            timerValue: '',
            tableData: [],
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.init()
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 4) {
                if (row.status_num == -1) {
                    return 'color: #FF3333;'
                } else if (row.status_num == 0) {
                    return 'color: #29bd7f;'
                } else if (row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            this.getOrderListData(this.checkStatusRadio);
        },
        // 请求订单列表
        getOrderListData(isCheck) {
            this.axios.get('order_list', {
                params: {
                    user_id: this.user.id,
                    is_check: isCheck
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        // 通过时间搜索订单
        searchOrderListByTime(timerValue) {
            this.axios.get('search_dateorder', {
                params: {
                    user_id: this.user.id,
                    style: 1,
                    start_time: timerValue[0],
                    end_time: timerValue[1]
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        // 通过审核状态请求订单列表
        getOrderListByCheckStatus(checkStatusRadio) {
            this.getOrderListData(checkStatusRadio);
        },
        findOrderDetail(orderId) {
            // alert(orderId)
            this.$router.push({
                'name': 'orderdetaillook',
                'query': {
                    oid: orderId
                }
            })
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.purchase-orderlist-main {
    position: relative;
    top: -63px;
    background-color: transparent;
}

.bg-head-nav {
    background-color: #d2f5e8;
    height: 64px;
}

.bg-head-h187 {
    height: 187px;
}

.timer {
    width: 161px;
    margin-left: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/PurchaseOrderList.vue